import { faChevronLeft, faChevronRight, faReply, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Button from '../../../Components/Button/Button'
import ForumAnswer from '../../../Components/ForumAnswer/ForumAnswer'
import Modal from '../../../Components/Modal/Modal'
import Style from './Question.module.css'
import Input from '../../../Components/Input/Input'
import { useHistory } from 'react-router-dom'
import { addAnswerAPi } from '../../../Api/ClientServices'
import { errorToast, succToast } from '../../../Utils/Toast/Toast'
const Question = (props) => {
    console.log(props)
    const history=useHistory()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data )=>{
        let info={
            question_id:window.location.pathname.split('/')[3],
            answer:data.answer
        }
        addAnswerAPi(info,(succ)=>{
            if(succ.status===1){
                succToast(succ.message)
                setPurchased(false)
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
            }
            else{
                errorToast(succ.message)
            }
        })
    }

    const[purchased,setPurchased]=useState(false)

    return (
        <ul className={Style.PageQuestionFourom}>
            <Modal show={purchased} modalClose={()=>setPurchased(false)} translate={40} >
                <form className={Style.ModalFormHolder} onSubmit={handleSubmit(onSubmit)} >
                    <h3 style={{fontSize:'1.2rem'}}><FontAwesomeIcon icon={faReply}/> پاسخ شما</h3>
                        <Input 
                        type='textarea'
                        {...register("answer", { required: true })}
                        inputtype={errors.answer ? "validTextArea" : "textArea"}
                        placeholder={'متن...'}
                        /> 
                        <Button Value={'ثبت جواب'} ClassBtn="confirmBtn"/>
                </form>
            </Modal>
            <FontAwesomeIcon icon={faChevronRight} className={Style.BackHolder } onClick={() => history.goBack()}/>
            <li className={Style.QuestionDivison}>
                <div className={Style.QuestionerInfo}>
                    <FontAwesomeIcon icon={faUser}/>
                    <p>{props.location.state.name}</p>
                    <div className={Style.ResponseInfo}>
                        <p>{props.location.state.date.split(' ')[0]}</p>
                        <div>{props.location.state.answer.length}<FontAwesomeIcon icon={faReply}/></div>
                    </div>
                </div>
                <div className={Style.QuestionText}>
                    <p>   {props.location.state.question} 
                    </p>
                    <div onClick={()=>setPurchased(true)}><FontAwesomeIcon icon={faChevronLeft}/>برای پاسخ کلیک کنید</div>
                </div>
            </li>
            {
                props.location.state.answer.slice(0).reverse().map(item=>{
                    return(
                        <ForumAnswer data={item}/>
                    )
                })
            }
        </ul>
    )
}

export default Question
